import { render, staticRenderFns } from "./custom-table-component.vue?vue&type=template&id=6ac39985"
import script from "./custom-table-component.vue?vue&type=script&lang=js"
export * from "./custom-table-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports